import { useTranslation } from "react-i18next";

import { CharacterCountProps } from "capitalrx-components-2.0/lib/forms/shared/CharacterCount/CharacterCount";
import styles from "capitalrx-components-2.0/lib/forms/shared/CharacterCount/styles.module.scss";
import { useValidity } from "capitalrx-components-2.0/lib/forms/ValidityGroup";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { getBasePropsFromHtmlProps } from "capitalrx-components-2.0/lib/utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "capitalrx-components-2.0/lib/utilities/getHtmlPropsFromBaseProps";

interface AppCharacterCountProps extends CharacterCountProps {
  readonly useDigitsCounter?: boolean;
}

export const CharacterCount = (props: AppCharacterCountProps ) => {
  const { characterCount, maxLength, children, useDigitsCounter } = props;
  const { t: translate } = useTranslation();
  const [invalid] = useValidity();

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.CharacterCount, "character-count", { invalid }],
    testIdPrefix: "character-count",
  });

  if (!maxLength) return children;

  const characterLengthMessage = translate(
    useDigitsCounter ? "CHARACTER_COUNT.digitsCount" : "CHARACTER_COUNT.characterCount",
    { characterCount, maxLength });

  return (
    <Body {...getBasePropsFromHtmlProps(baseHtmlProps)} inline size="mini" >
      {characterLengthMessage}
      {children
        && (<>. {children}&nbsp;</>)
      }
    </Body>
  );
};
